import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';

import { MatCoordinatorGuard } from './guards/mat-coordinator.guard';
import { AdminGuard } from './guards/admin.guard';
import { ActiveUserGuard } from './guards/active-user.guard';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    canActivate: [MsalGuard, ActiveUserGuard],
    loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'create-request',
    canActivate: [MsalGuard, ActiveUserGuard],
    loadChildren: () => import('./components/create-request/create-request.module').then(m => m.CreateRequestModule)
  },
  {
    path: 'request',
    canActivate: [MsalGuard, ActiveUserGuard],
    loadChildren: () => import('./components/create-request/create-request.module').then(m => m.CreateRequestModule)
  },
  {
    path: 'view-page',
    canActivate: [MsalGuard, ActiveUserGuard],
    loadChildren: () => import('./components/view-page/view-page.module').then(m => m.ViewPageModule)
  },
  {
    path: 'map-view',
    canActivate: [MsalGuard, MatCoordinatorGuard],
    loadChildren: () => import('./components/map-view/map-view.module').then(m => m.MapViewModule)
  },
  {
    path: 'future-view',
    canActivate: [MsalGuard, MatCoordinatorGuard],
    loadChildren: () => import('./components/future-view/future-view.module').then(m => m.FutureViewModule)
  },
  {
    path: 'inventory',
    canActivate: [MsalGuard, MatCoordinatorGuard],
    loadChildren: () => import('./components/inventory-management/inventory.module').then(m => m.InventoryModule)
  },
  {
    path: 'admin',
    canActivate: [MsalGuard, AdminGuard],
    loadChildren: () => import('./components/admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'unauthorized',
    loadChildren: () => import('./components/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule)
  },
  {
    path: 'logged-out',
    loadChildren: () => import('./components/logged-out/logged-out.module').then(m => m.LoggedOutModule)
  },
  { path: '**', redirectTo: '/dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
      ? 'enabledNonBlocking'
      : 'disabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }